import { SKIP_BUTTON_VALUE } from "@/components/landing/FormFields";
import styles from "./SkipLeadForm.module.css";
import { handleFormSubmit } from "@/components/landing/DynamicForm/formSubmitUtils";
import { SyntheticEvent } from "react";
import { useRouter } from "next/router";
import type { Site } from "@/types/sites";
import type { LandingPageTemplateResponse } from "@/types/landing";
import { emailRequiredToggle, buttonToggle } from "src/utils/utils";

type SkipLeadFormProps = ({
    skipButtonText,
    isInPopupAndNotBannerflow,
    site,
    landingPage,
}: {
    skipButtonText: string;
    isInPopupAndNotBannerflow?: boolean;
    site: Site | null;
    landingPage: LandingPageTemplateResponse | null;
}) => React.ReactElement;
export const SkipLeadForm: SkipLeadFormProps = ({
    skipButtonText,
    isInPopupAndNotBannerflow,
    site,
    landingPage,
}) => {
    const router = useRouter();
    const colourClass = isInPopupAndNotBannerflow
        ? styles.skipButtonColourSpinner
        : styles.skipButtonColour;

    const handleSubmit = async (e: SyntheticEvent<HTMLButtonElement>) => {
        e.preventDefault();

        const offerPageRedirectPath = await handleFormSubmit(
            e,
            site,
            landingPage,
            true
        );

        if (offerPageRedirectPath) {
            await router.push({
                pathname: offerPageRedirectPath,
                query: router.query,
            });
        }
    };

    const checkIfFormCanSkip = async (e: SyntheticEvent<HTMLButtonElement>) => {
        e.preventDefault();
        const form = document.querySelector("form");
        if (form) {
            emailRequiredToggle(form, false);

            if (form.checkValidity()) {
                buttonToggle(form, true);
                await handleSubmit(e);
            } else {
                (form as HTMLFormElement).reportValidity();
                emailRequiredToggle(form, true);
            }
        }
    };

    return (
        <button
            className={[styles.skipButton, colourClass].join(" ")}
            value={SKIP_BUTTON_VALUE}
            name="skipLead"
            onClick={(e) => checkIfFormCanSkip(e)}
        >
            {skipButtonText}
        </button>
    );
};
